var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg015Explore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BBE0F1"
    },
    cx: 256,
    cy: 49.939,
    r: 42.44
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M256,92.378c14.127,0,26.634-6.909,34.348-17.525 c-38.647,4.47-61.909-34.975-37.526-67.222c-21.953,1.627-39.261,19.94-39.261,42.308C213.561,73.378,232.562,92.378,256,92.378z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7F9AE6"
    },
    cx: 256,
    cy: 285.97,
    r: 218.53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M438.577,406.072 C154.245,446.656,108.696,162.011,187.013,78.567C100.131,107.452,37.471,189.389,37.471,285.971 C37.471,406.661,135.31,504.5,256,504.5C332.324,504.5,399.496,465.362,438.577,406.072z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BBE0F1"
    },
    cx: 256,
    cy: 285.97,
    r: 160.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6B7BAB"
    },
    cx: 256,
    cy: 162.01,
    r: 16.415
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6B7BAB"
    },
    cx: 132.04,
    cy: 285.97,
    r: 16.415
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6B7BAB"
    },
    cx: 256,
    cy: 409.93,
    r: 16.415
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6B7BAB"
    },
    cx: 379.96,
    cy: 285.97,
    r: 16.415
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D66274"
    },
    d: "M328.395,200.443l-84.248,45.236c-12.068,6.48-21.96,16.372-28.44,28.44l-45.236,84.248 c-4.546,8.466,4.667,17.679,13.133,13.133l84.248-45.236c12.068-6.48,21.96-16.371,28.44-28.44l45.236-84.248 C346.074,205.109,336.862,195.897,328.395,200.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.472,358.367c-4.546,8.466,4.667,17.679,13.133,13.133l84.248-45.236 c6.034-3.24,11.524-7.333,16.316-12.124l-56.337-56.337c-4.792,4.792-8.884,10.281-12.124,16.315L170.472,358.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M216.142,333.329c-1.919,0-3.839-0.732-5.303-2.196 c-2.929-2.93-2.929-7.678,0-10.607l79.716-79.716c2.929-2.928,7.678-2.928,10.606,0c2.929,2.93,2.929,7.678,0,10.607l-79.716,79.716 C219.981,332.597,218.062,333.329,216.142,333.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M395.304,366.109c13.599-23.589,21.381-50.954,21.381-80.137 c0-88.744-71.941-160.685-160.685-160.685c-33.893,0-65.328,10.502-91.247,28.418C309.743,111.065,417.701,225.892,395.304,366.109z "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.827,126.145c-31.237-31.237-70.01-52.189-112.216-61.192c1.525-4.841,2.328-9.907,2.328-15.013 C305.939,22.402,283.537,0,256,0s-49.939,22.402-49.939,49.939c0,5.105,0.803,10.172,2.328,15.013 c-42.206,9.003-80.979,29.955-112.216,61.192c-42.691,42.691-66.202,99.452-66.202,159.827c0,28.611,5.277,56.499,15.685,82.889 c1.52,3.852,5.878,5.744,9.729,4.225c3.854-1.52,5.745-5.875,4.226-9.729c-9.713-24.629-14.639-50.665-14.639-77.385 c0-116.362,94.667-211.029,211.029-211.029S467.03,169.609,467.03,285.971C467.029,402.333,372.362,497,256,497 c-37.255,0-73.87-9.837-105.888-28.447c-31.08-18.064-57.225-43.946-75.607-74.848c-2.118-3.559-6.719-4.732-10.28-2.61 c-3.56,2.117-4.729,6.72-2.611,10.28c19.685,33.088,47.681,60.802,80.961,80.147C176.878,501.461,216.101,512,256,512 c60.375,0,117.135-23.511,159.827-66.202c42.691-42.691,66.202-99.452,66.202-159.826 C482.029,225.597,458.518,168.836,415.827,126.145z M288.671,62.28c-10.728-1.544-21.638-2.338-32.671-2.338 s-21.943,0.794-32.671,2.338c-1.483-3.929-2.268-8.115-2.268-12.34C221.061,30.674,236.734,15,256,15s34.939,15.674,34.939,34.939 C290.939,54.165,290.154,58.351,288.671,62.28z M324.848,193.836l-84.249,45.235c-13.408,7.198-24.3,18.091-31.5,31.499 l-45.235,84.248c-3.616,6.735-2.414,14.893,2.992,20.298c3.326,3.326,7.693,5.061,12.13,5.061c2.775,0,5.576-0.678,8.167-2.069 l84.249-45.236c13.408-7.198,24.3-18.091,31.5-31.499l45.235-84.248c3.616-6.735,2.414-14.893-2.992-20.298 C339.74,191.422,331.582,190.219,324.848,193.836z M264.305,319.656l-84.249,45.236c-0.955,0.513-1.828,0.384-2.595-0.383 s-0.895-1.641-0.382-2.596l45.235-84.248c1.697-3.161,3.657-6.143,5.84-8.933l45.084,45.084 C270.448,316,267.466,317.959,264.305,319.656z M334.538,207.434c0.767,0.767,0.895,1.64,0.382,2.595l-45.235,84.248 c-1.697,3.161-3.656,6.143-5.84,8.933l-45.084-45.084c2.79-2.183,5.772-4.142,8.933-5.84l84.249-45.235 c0.382-0.205,0.751-0.308,1.106-0.308C333.581,206.743,334.079,206.974,334.538,207.434z M333.854,136.855 c-23.846-12.475-50.768-19.068-77.854-19.068c-92.737,0-168.185,75.447-168.185,168.186c0,92.737,75.447,168.185,168.185,168.185 s168.185-75.447,168.185-168.185c0-49.702-21.817-96.595-59.856-128.655c-3.168-2.671-7.899-2.268-10.568,0.901 c-2.669,3.167-2.266,7.898,0.901,10.567c34.65,29.204,54.523,71.917,54.523,117.187c0,84.466-68.718,153.185-153.185,153.185 s-153.185-68.719-153.185-153.185c0-84.467,68.718-153.186,153.185-153.186c24.675,0,49.192,6.003,70.901,17.359 c3.67,1.921,8.202,0.501,10.122-3.169C338.943,143.307,337.524,138.774,333.854,136.855z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg015Explore);
export default __webpack_public_path__ + "static/media/015-explore.e7cb9f678248bbe7f71b6f16924ee882.svg";
export { ForwardRef as ReactComponent };